<template>
  <v-card
    class="pa-2"
    :ripple="ripple"
    @click="() => {if (ripple) $emit('click')}"
  >
    <v-row no-gutters>
      <v-col
        cols="3"
        md="2"
        align-self="center"
        class="text-center font-weight-bold"
      >
        {{ reservation.covers || 'UNDEF' }}
      </v-col>
      <v-col
        cols="6"
        md="4"
        align-self="center"
        class="font-weight-bold"
      >
        <div>
          {{ reservationTime }}
        </div>
        <div>
          {{ reserveeName || 'UNDEF' }}
        </div>
      </v-col>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        cols="3"
        align-self="center"
        class="d-flex justify-space-around"
      >
        <div v-if="hasAllergies(reservation) && $ftStyle.reservation.allergyIcon">
          <v-icon color="error">
            {{ $ftStyle.reservation.allergyIcon }}
          </v-icon>
        </div>
        <div v-if="reservation.occasionId != null">
          <v-icon>mdi-gift</v-icon>
        </div>
        <div v-if="reservation.walkIn">
          <v-icon>mdi-walk</v-icon>
        </div>
        <div v-if="hasSpecialRequests(reservation)">
          <v-icon>mdi-message-text</v-icon>
        </div>
        <div v-if="hasHiddenRequests(reservation)">
          <v-icon>mdi-message-outline</v-icon>
        </div>
        <div v-if="reservation.hasOverbookedTable">
          <v-icon color="warning">
            mdi-alert
          </v-icon>
        </div>
      </v-col>
      <v-col
        cols="3"
        align-self="center"
        class="d-flex justify-end"
      >
        <table-names-card
          :table-names="tables || 'UNDEF'"
          left
          tooltip-color="primary"
          :disable-tooltip="ripple"
        />
      </v-col>
    </v-row>
    <v-divider
      v-if="($vuetify.breakpoint.smAndDown && reservation.walkIn || reservation.notes || reservation.specialRequests) || showLocation || !!errorMessage"
      class="mt-1 grey darken-1"
    />
    <div class="d-flex justify-space-between pt-1">
      <div
        v-if="errorMessage"
        class="error--text pl-2 text-no-wrap text-truncate"
      >
        {{ errorMessage }}
      </div>
      <div
        v-if="$vuetify.breakpoint.smAndDown"
        class="d-flex"
      >
        <div v-if="hasAllergies(reservation) && $ftStyle.reservation.allergyIcon">
          <v-icon color="error">
            {{ $ftStyle.reservation.allergyIcon }}
          </v-icon>
        </div>
        <div v-if="reservation.occasionId != null">
          <v-icon>mdi-gift</v-icon>
        </div>
        <div v-if="reservation.walkIn">
          <v-icon>mdi-walk</v-icon>
        </div>
        <div v-if="hasSpecialRequests(reservation)">
          <v-icon>mdi-message-text</v-icon>
        </div>
        <div v-if="hasHiddenRequests(reservation)">
          <v-icon>mdi-message-outline</v-icon>
        </div>
        <div v-if="reservation.hasOverbookedTable">
          <v-icon>mdi-alert</v-icon>
        </div>
      </div>
      <div
        v-if="showLocation"
        class="font-weight-bold text-no-wrap text-truncate pl-2 primary--text"
      >
        <span v-if="$vuetify.breakpoint.mdAndUp">Location: </span>
        {{ reservation.locationName }}
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'
import floorPlanHelpers from '../../mixins/floorPlanHelpers'
export default {
  name: 'ReservationCard',
  mixins: [floorPlanHelpers],
  props: {
    reservation: {
      type: Object,
      default () {return {}}
    },
    error: {
      type: Array,
      default () {return []}
    },
    ripple: {
      type: Boolean,
      default: true
    },
    showLocation: Boolean,
  },
  data () {
    return {showTooltip: false}
  },
  computed: {
    tables () {
      return this.reservation.tableAssignments?.reduce((acc, t) => {
        if (t.locationTableName) {
          acc += !acc.length ? t.locationTableName : ', ' + t.locationTableName
        }
        return acc
      }, '') ?? ''
    },
    reservationDetails () {
      return this.reservation.details?.[0] ?? {}
    },
    reservationTime () {
      return moment(this.reservation.dateTime)?.format('h:mm A')
    },
    reserveeName () {
      return this.reservationDetails.name
    },
    errorMessage () {return this.error.join(', ')}
  },
  methods: {
    hasAllergies (reservation) {
      return !!reservation.details?.find(d => d.member?.allergyInformation)
    },
    hasSpecialRequests (reservation) {
      return !!reservation.memberSpecialRequests ||
        !!reservation.details?.find(d => d.member?.diningSpecialRequests)
    },
    hasHiddenRequests (reservation) {
      return !!reservation.specialRequests
    }
  }
}
</script>

<style scoped>
.v-card::before {
  background: none;
}
</style>
